import React from "react"

const TableHeadSortTypeIndicator = ({ sortByType }) => {
  return (<>
    {sortByType === 'DESC' ? (<>
      <i className="bi bi-arrow-up-short"></i>
    </>) : (<>
      <i className="bi bi-arrow-down-short"></i>
    </>)}
  </>)
}

export default TableHeadSortTypeIndicator;
